import Vue from 'vue';
import axios from 'axios';
import router from '@/router';
import store from '@/store';

export default {
  namespaced: true,
  state: {
    user: {
      planName: '',
      nm: '',
      corpNm: '',
      manageCorpNm: '',
      mailAddress: '',
      isLogin: false,
      isTrialExpiredUpClose: false,
      userAuthTypeText: '',
      tutorial: {
        isShowDiagSectionTutorial: true,
        isShowDiagAnswerFormTutorial: true,
        isShowDiagManagementTutorial: true,
        isShowDiagManagementDetailTutorial: true,
        isShowDiagManagementDetailSaveTutorial: true,
        isShowTaskListTutorial: true,
        isShowDiagResultTutorial: true,
        isShowDiagHumanCapitalInput: true,
        isShowDiagHumanCapitalReport: true,
      }
    },
    authorityList: [],
    authorityListForLaborConsultant: [],
    corpAuthorityList: [],
    errorMessage: '',
    lastAccessUrl: '',
  },
  mutations: {
    LOGIN (state, payload) {
      state.user = payload;
      state.user.isLogin = true;
    },
    LOGOUT (state) {
      state.user = {
        planName: '',
        nm: '',
        corpNm: '',
        manageCorpNm: '',
        mailAddress: '',
        isLogin: false,
        isTrialExpiredUpClose: false,
        userAuthTypeText: '',
        tutorial: {
          isShowDiagSectionTutorial: true,
          isShowDiagAnswerFormTutorial: true,
          isShowDiagManagementTutorial: true,
          isShowDiagManagementDetailTutorial: true,
          isShowDiagManagementDetailSaveTutorial: true,
          isShowTaskListTutorial: true,
          isShowDiagResultTutorial: true,
          isShowDiagHumanCapitalInput: true,
          isShowDiagHumanCapitalReport: true,
        }
      };
      var array = [];
      state.authorityList = array;
      state.corpAuthorityList = array;
    },
    SET_AUTH_MASTER (state, payload) {
      state.authorityList = payload;
    },
    SET_AUTH_MASTER_FOR_LABOR_CONSULTANT(state, payload) {
      state.authorityListForLaborConsultant = payload;
    },
    SET_CORP_AUTH_MASTER(state, payload) {
      state.corpAuthorityList = payload;
    },
    SET_IS_SHOW_DIAG_SECTION_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagSectionTutorial = payload;
    },
    SET_IS_SHOW_DIAG_ANSWER_FORM_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagAnswerFormTutorial = payload;
    },
    SET_IS_SHOW_DIAG_MANAGEMENT_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagManagementTutorial = payload;
    },
    SET_IS_SHOW_DIAG_MANAGEMENT_DETAIL_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagManagementDetailTutorial = payload;
    },
    SET_IS_SHOW_DIAG_MANAGEMENT_DETAIL_SAVE_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagManagementDetailSaveTutorial = payload;
    },
    SET_IS_SHOW_TASK_LIST_TUTORIAL(state, payload) {
      state.user.tutorial.isShowTaskListTutorial = payload;
    },
    SET_IS_SHOW_DIAG_RESULT_TUTORIAL(state, payload) {
      state.user.tutorial.isShowDiagResultTutorial = payload;
    },
    SET_IS_SHOW_DIAG_HUMAN_CAPITAL_INPUT(state, payload) {
      state.user.tutorial.isShowDiagHumanCapitalInput = payload;
    },
    SET_IS_SHOW_DIAG_HUMAN_CAPITAL_REPORT(state, payload) {
      state.user.tutorial.isShowDiagHumanCapitalReport = payload;
    },
    SET_LAST_ACCESS_URL(state, payload) {
      state.lastAccessUrl = payload;
    }
  },
  getters: {
    isLogin (state) {
      return state.user.isLogin;
    },
    getErrorMessage (state) {
      return state.errorMessage;
    },
    getUser (state) {
      return {
        planName: state.user.planName,
        nm: state.user.nm,
        corpNm: state.user.corpNm,
        manageCorpNm: state.user.manageCorpNm,
        mailAddress: state.user.mailAddress,
        userAuthTypeText: state.user.userAuthTypeText,
        tutorial: state.user.tutorial,
      };
    },
    isTrialExpiredUpClose(state) {
      return state.user.isTrialExpiredUpClose;
    },
    getAuthMaster(state) {
      return state.authorityList;
    },
    getAuthMasterForLaborConsultant(state) {
      return state.authorityListForLaborConsultant;
    },
    getCorpAuthMaster(state) {
      return state.corpAuthorityList;
    },
    getLastAccessUrl(state) {
      return state.lastAccessUrl;
    }
  },
  actions: {
    async login ({commit}, payload) {
      await axios.get('/ld/sanctum/csrf-cookie')
        .catch(() => {
          return;
        });

      let result = {};
      await axios.post('/ld/login', {
        'mail_address': payload.mailAddress,
        'password': payload.password,
      }).then((res) => {
        commit('LOGIN', res.data.user);
        commit('SET_AUTH_MASTER', res.data.authorityList);
        commit('SET_AUTH_MASTER_FOR_LABOR_CONSULTANT', res.data.authorityListForLaborConsultant);
        commit('SET_CORP_AUTH_MASTER', res.data.corpAuthorityList);
        store.dispatch('diag/init');
        store.dispatch('doc/init');
        store.dispatch('master/init');
        store.dispatch('portal/init');
        store.dispatch('solution/init');
        store.dispatch('user/init');
        store.dispatch('trialEntry/init');
        result = res.data.user;
      }).catch((e) => {
        throw e;
      })
      return result;
    },
    async logout({commit}, payload) {
      await axios.post('/ld/logout', {
      }).then(() => {
        commit('LOGOUT');
        store.dispatch('diag/init');
        store.dispatch('doc/init');
        store.dispatch('master/init');
        store.dispatch('portal/init');
        store.dispatch('solution/init');
        store.dispatch('user/init');
        store.dispatch('trialEntry/init');
        store.dispatch('alert/setMessage', 'ログアウトしました。');
        if (!payload.isSupple) {
          router.push({ name: 'login' });
        }
        else {
          router.push({ name: 'login', query: {supple: null} });
        }
      }).catch(() => {
        //console.log(e);
      })
    },
    async disagreeTerms({commit}, payload) {
      await axios.post('/ld/logout', {
      }).then(() => {
        commit('LOGOUT');
        store.dispatch('diag/init');
        store.dispatch('doc/init');
        store.dispatch('master/init');
        store.dispatch('portal/init');
        store.dispatch('solution/init');
        store.dispatch('user/init');
        store.dispatch('trialEntry/init');

        if (!payload.isSupple) {
          router.push({ name: 'login' });
        }
        else {
          router.push({ name: 'login', query: {supple: null} });
        }
      }).catch(() => {
        //console.log(e);
      })
    },
    sessionExpire({commit}) {
      commit('LOGOUT');
      store.dispatch('diag/init');
      store.dispatch('doc/init');
      store.dispatch('master/init');
      store.dispatch('portal/init');
      store.dispatch('solution/init');
      store.dispatch('user/init');
      store.dispatch('trialEntry/init');

      store.dispatch('alert/setMessage', 'セッションがタイムアウトしました。');
      router.push({ name: 'login' });
    },
    forbiddenAccess({commit}, payload) {
      commit('LOGOUT');
      store.dispatch('diag/init');
      store.dispatch('doc/init');
      store.dispatch('master/init');
      store.dispatch('portal/init');
      store.dispatch('user/init');
      store.dispatch('trialEntry/init');

      Vue.prototype.$toast.auth('エラーが発生しました。再度ログインしてください。' + payload.data.message, { title: payload.data.title, solid: true, duration: 8000, appendToast: true });
      router.push({ name: 'login' });
    },
    async getAuthority() {
      let result = {};
      await axios.post('/ld/api/auth/getAuthority', {})
        .then((res) => {
          result = res.data;
        }).catch(() => {
          //console.log(e);
        });
      return result;
    },
    setIsShowDiagSectionTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_SECTION_TUTORIAL', payload);
    },
    setIsShowDiagAnswerFormTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_ANSWER_FORM_TUTORIAL', payload);
    },
    setIsShowDiagManagementTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_MANAGEMENT_TUTORIAL', payload);
    },
    setIsShowDiagManagementDetailTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_MANAGEMENT_DETAIL_TUTORIAL', payload);
    },
    setIsShowDiagManagementDetailSaveTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_MANAGEMENT_DETAIL_SAVE_TUTORIAL', payload);
    },
    setIsShowTaskListTutorial({commit}, payload) {
      commit('SET_IS_SHOW_TASK_LIST_TUTORIAL', payload);
    },
    setIsShowDiagResultTutorial({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_RESULT_TUTORIAL', payload);
    },
    setIsShowDiagHumanCapitalInput({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_HUMAN_CAPITAL_INPUT', payload);
    },
    setIsShowDiagHumanCapitalReport({commit}, payload) {
      commit('SET_IS_SHOW_DIAG_HUMAN_CAPITAL_REPORT', payload);
    },
    setLastAccessUrl({commit}, payload) {
      commit('SET_LAST_ACCESS_URL', payload);
    }
  },
}
